/*我的订单*/
const Order = r => require.ensure([], () => r(require('./')), 'Order')
/*订单列表*/
const OrderList = r => require.ensure([], () => r(require('./order-list')), 'OrderList')
/*订单详情*/
const OrderDetail = r => require.ensure([], () => r(require('./order-detail')), 'OrderDetail')
/*到检验证码*/
const VerificationCode = r => require.ensure([], () => r(require('./verification-code')), 'VerificationCode')

export default {
  path:'/order',
  component: Order,
  meta: { title: '我的订单' },
  redirect: '/order/list',
  children:[
    {
      path: 'list',
      name: 'orderList',
      meta: { title: '我的订单' },
      component: OrderList
    },
    {
      path: 'detail/:oid',
      name: 'orderDetail',
      meta: { title: '订单详情' },
      component: OrderDetail
    },{
      path: 'qrcode/:qid',
      name: 'verificationCode',
      meta: { title: '到检验证码' },
      component: VerificationCode
    }
  ]
}


// WEBPACK FOOTER //
// ./src/views/order/router.js